import { EXPIRY_LOGIN_POP_UP_OPEN, EXPIRY_LOGIN_POP_UP_CLOSE } from '../../constant';

const initialState = {
  isOpen: false,
  warnLostMsg: false,
};

const expiryLoginReducer = (state = initialState, action) => {
  const { type } = action;
  switch (type) {
    case EXPIRY_LOGIN_POP_UP_OPEN:
      return { ...state, isOpen: true, warnLostMsg: action.warnLostMsg };
    case EXPIRY_LOGIN_POP_UP_CLOSE:
      return { ...state, isOpen: false, warnLostMsg: false };
    default:
      return state;
  }
};

export default expiryLoginReducer;
export { expiryLoginReducer };
